import { Box, Grid } from "@material-ui/core";
import Skeleton from "@saleor/components/Skeleton";
import { ContractCheckoutQuery } from "@saleor/graphql";
import React from "react";
import { FormattedMessage } from "react-intl";

import useStyles from "./styles";

interface BoxInfoCustomerProps {
  data: ContractCheckoutQuery;
  count: number;
}

const BoxInfoCustomer: React.FC<BoxInfoCustomerProps> = ({ data, count }) => {
  const classes = useStyles({});
  return (
    <Grid item xs={6} md={3}>
      <Box className={classes.boxCustomer}>
        <div className={classes.boxHeader}>
          <div className={classes.headerTitle}>
            <FormattedMessage defaultMessage={"Sold to"} />
          </div>
          <div className={classes.headerId}>
            {data.contractCheckout?.customer.code}
          </div>
        </div>
        <div className={classes.boxBody}>
          <div className={classes.infoRow}>
            <div className={classes.infoLeft}>
              <FormattedMessage defaultMessage={"ชื่อลูกค้า"} />
            </div>
            <div className={classes.infoRight}>
              {data ? (
                <span className={classes.name}>
                  {data.contractCheckout?.customer?.name}
                </span>
              ) : (
                <Skeleton />
              )}
            </div>
          </div>
          <div className={classes.infoRow}>
            <div className={classes.infoLeft}>
              <FormattedMessage defaultMessage={"มีสินค้าในตะกร้า"} />
            </div>
            <div className={classes.infoRight}>
              <b>{count || 0}</b> <FormattedMessage defaultMessage={"รายการ"} />
            </div>
          </div>
        </div>
      </Box>
    </Grid>
  );
};

export default BoxInfoCustomer;
